<template>
  <div class="body1">
    <loading :isLoading="isLoading"></loading>
    <!-- 教师数据 -->
    <div class="left">
      <div class="top">
				<div class="titleBox">
          <div class="title">在线时长</div>
        </div>
				<div class="info_box">
          <div class="info">
						<span>{{ OnlineDuration[0] }}</span>
            <span>累计时长</span>
          </div>
          <div class="info">
						<span>{{ OnlineDuration[1] }}</span>
            <span>人均使用时长</span>
          </div>
        </div>
				<div class="dataBox">
					<loginTime style="height: calc(100% -  50px);width: calc(100% -  50px);" :yearArray="yearArray"></loginTime>
        </div>
      </div>
      <div class="bottom">
				<div class="titleBox">
          <div class="title">登录频次</div>
        </div>
				<div class="info_box">
          <div class="info2">
						<span>{{ LoginFrequency[0] }}</span>
            <span>登录频次</span>
          </div>
          <div class="info2">
						<span>{{ LoginFrequency[1] }}</span>
            <span>教师登录频次</span>
          </div>
					<div class="info2">
						<span>{{ LoginFrequency[2] }}</span>
            <span>学生登录频次</span>
          </div>
					<div class="info2">
						<span>{{ LoginFrequency[3] }}</span>
            <span>人均登录频次</span>
          </div>
        </div>
				<div class="dataBox">
					<toolUser style="height: calc(100% - 50px);width: calc(100% - 50px)" :Josn="loginCountYearArray"/>
        </div>
      </div>
    </div>
    <div class="center">
      <div class="top">
				<div class="titleBox">
          <div class="title">总量增幅</div>
        </div>
				<div class="dataBox">
         <courseNum style="height: calc(100% - 20px);width: calc(100% - 50px)" :weekCourse2="weekCourse2"/>
        </div>
      </div>
      <div class="bottom">
				<div class="titleBox">
          <div class="title">学校排行榜</div>
          <el-select v-model="selectArea2" @change="typeChangeArea2" class="selectBox">
            <el-option label="全部" value=""></el-option>
            <!-- <el-option label="南山区" :value="0"></el-option> -->
            <el-option :label="item.dest" :value="item.dest" v-for="(item,index) in areaArray" :key="index"></el-option>    
          </el-select>
        </div>
				<div class="dataBox">
         <schoolRank :rankData="schoolRankData"/>
        </div>
      </div>
    </div>
    <div class="right">
      <div class="top" style="border-radius: 5px">
				<div class="titleBox">
          <div class="title">基础概况</div>
        </div>
				<div class="info_box">
          <div class="info3">
						<span>{{ BasicOverview[0] }}</span>
            <span>用户总数（个）</span>
          </div>
          <div class="info3">
						<span>{{ BasicOverview[1] }}</span>
            <span>本月新增用户（个）</span>
          </div>
					<div class="info3">
						<span>{{ BasicOverview[2] }}</span>
            <span>本月新增登录（次）</span>
          </div>
        </div>
				<div class="dataBox">
					<TeaFre style="height: calc(100% - 50px)" :monthArray="monthArray"/>
        </div>
      </div>
      <div class="bottom">
				<div class="titleBox">
          <div class="title">课程排行榜</div>
          <el-select v-model="selectArea3" @change="typeChangeArea3" class="selectBox">
            <el-option label="全部" value=""></el-option>
            <!-- <el-option label="南山区" :value="0"></el-option> -->
            <el-option :label="item.dest" :value="item.dest" v-for="(item,index) in areaArray" :key="index"></el-option>    
          </el-select>
        </div>
				<div class="dataBox">
         <courseRank :rankData="courseRankData"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loginTime from './chartList/loginTime'
import toolUser from './chartList/toolUser'
import TeaFre from './chartList/teaFre'
import schoolRank from './chartList/schoolRank'
import courseRank from './chartList/courseRank'
import courseNum from './chartList/courseNum'
import loading from "../../../components/loading.vue";
export default {
  components: {
		loginTime,
		toolUser,
		TeaFre,
		schoolRank,
		courseRank,
		courseNum,
    loading,
  //   TeaFre,
  //   TeaAct,
  //   TeaData,
  //   FunPlot,
  //   WorkNum,
  //   WorkTime,
  //   ToolUse,
  
  //   TeaActSecond,
  //   CateRank,
  },
  props: {
    oid: {
      type: String,
    },
    org: {
      type: String,
    },
  },
  data() {
    return {
      isLoading: false,
			yearArray:"0",
			OnlineDuration:['0','0'],
			BasicOverview:['0','0','0'],
			LoginFrequency:['0','0','0','0'],
			loginCountYearArray:{},
			monthArray:[],
			schoolRankData:[
				// {schoolName:"深圳市南山实验小学",area:"南山区",teacherLogin:0,studentLogin:0,teaching:0,submitJob:0,score:0},
				// {schoolName:"海滨实验小学逾...",area:"南山区",teacherLogin:0,studentLogin:0,teaching:0,submitJob:0,score:0},
				// {schoolName:"深圳市海滨实验小学",area:"南山区",teacherLogin:0,studentLogin:0,teaching:0,submitJob:0,score:0},
				// {schoolName:"深圳市海滨实验小学",area:"南山区",teacherLogin:0,studentLogin:0,teaching:0,submitJob:0,score:0},
				// {schoolName:"深圳市海滨实验小学",area:"南山区",teacherLogin:0,studentLogin:0,teaching:0,submitJob:0,score:0},
				// {schoolName:"深圳市海滨实验小学",area:"南山区",teacherLogin:0,studentLogin:0,teaching:0,submitJob:0,score:0},
				// {schoolName:"深圳市海滨实验小学",area:"南山区",teacherLogin:0,studentLogin:0,teaching:0,submitJob:0,score:0},
				// {schoolName:"深圳市海滨实验小学",area:"南山区",teacherLogin:0,studentLogin:0,teaching:0,submitJob:0,score:0},
			],
      schoolRankData2: [],
			courseRankData:[
			],
      courseRankData2:[
			],
			weekCourse2:[
			],
      selectArea2:"",
      selectArea3:"",
      areaArray: []
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    format(percentage) {
      return percentage + "%";
    },
    getMonth() {
      // 获取当前时间
      var currentDate = new Date();

      // 获取本月的年份和月份
      var currentYear = currentDate.getFullYear();
      var currentMonth = currentDate.getMonth() + 1; // 月份从0开始，需要加1

      // 获取上个月的年份和月份
      var lastMonthYear, lastMonth;
      if (currentMonth === 1) {
        lastMonthYear = currentYear - 1;
        lastMonth = 12;
      } else {
        lastMonthYear = currentYear;
        lastMonth = currentMonth - 1;
      }
      // 获取本月的第一天和最后一天的日期
      var firstDayOfMonth = new Date(currentYear, currentMonth - 1, 1);
      var lastDayOfMonth = new Date(currentYear, currentMonth, 0);

      // 获取上个月的第一天和最后一天的日期
      var firstDayOfLastMonth = new Date(lastMonthYear, lastMonth - 1, 1);
      var lastDayOfLastMonth = new Date(lastMonthYear, lastMonth, 0);

      // 构建本月日期的数组
      var currentMonthDates = [];
      for (var i = 1; i <= lastDayOfMonth.getDate(); i++) {
        let a = new Date(currentYear, currentMonth - 1, i);
        currentMonthDates.push(
          a.getFullYear() + "-" + (a.getMonth() + 1) + "-" + a.getDate()
        );
      }

      // 构建上个月日期的数组
      var lastMonthDates = [];
      for (
        var j = firstDayOfLastMonth.getDate();
        j <= lastDayOfLastMonth.getDate();
        j++
      ) {
        let a = new Date(lastMonthYear, lastMonth - 1, j);
        lastMonthDates.push(
          a.getFullYear() + "-" + (a.getMonth() + 1) + "-" + a.getDate()
        );
      }

      return {
        lastWeek: lastMonthDates, //上月
        toWeek: currentMonthDates, //本月
      };
    },
    typeChangeArea2(){
      this.schoolRankData = this.schoolRankData2.filter(el => {
        return  this.selectArea2 == '' ? el : el.dest == this.selectArea2
      })
    },
    typeChangeArea3(){
      this.courseRankData = this.courseRankData2.filter(el => {
        return  this.selectArea3 == '' ? el : el.dest == this.selectArea3
      })
    },
    getData() {
      this.isLoading = true;
      let params = [
        {
          oid: this.oid,
          org: this.org,
        },
      ];
      this.ajax
        .post(this.$store.state.api + "selectDataBoardCitySz", params)
        .then((res) => {
          this.isLoading = false;
          let _grade = res.data[0]; //年级
          let _subject = res.data[1]; //学科
          this._grade = JSON.parse(JSON.stringify(_grade));
          this._subject = JSON.parse(JSON.stringify(_subject));
          let _themeList = res.data[2]; //主题
          this.BasicOverview[0] = res.data[3][0].count //总数
          this.BasicOverview[1] = res.data[4][0].count //本月新增用户
          let _monthArray = res.data[5] //用户半年内登录次数
          let loginCountMonthArray = [];
          const date = new Date();
          var Month = date.getMonth() + 1;
          var Year = date.getFullYear();
          for (var i = Month; i > Month - 6; i--) {
            if (i <= 0) {
              loginCountMonthArray.push({
                Year: Year - 1,
                Month: 12 + i,
                user: 0,
              });
            } else {
              loginCountMonthArray.push({
                Month: i,
                Year: Year,
                user: 0,
              });
            }
          }
          loginCountMonthArray = loginCountMonthArray.reverse();
          for (var i = 0; i < _monthArray.length; i++) {
            let _date = new Date(_monthArray[i].time);
            var _month = _date.getMonth() + 1;
            var _year = _date.getFullYear();
            for (var j = 0; j < loginCountMonthArray.length; j++) {
              if (
                _month == loginCountMonthArray[j].Month &&
                _year == loginCountMonthArray[j].Year
              ) {
                // loginCountMonthArray[j].user++
                loginCountMonthArray[j].user += _monthArray[i].usernum;
                break;
              }
            }
          }
          let _yearCount = _monthArray[_monthArray.length - 1].usernum - _monthArray[_monthArray.length - 2].usernum 
          this.BasicOverview[2] = _yearCount > 0 ? _yearCount : 0 //较上月新增登录次数

          this.monthArray = loginCountMonthArray


          let _courseRank = res.data[6] //课程排行榜
          let _courseLastWeek = []
          let _courseNow = []
          for (var i = 0; i < _courseRank.length; i++) {
            _courseLastWeek.push({courseId:_courseRank[i].courseId,title:_courseRank[i].title,total:_courseRank[i].lastweek})
            _courseNow.push({courseId:_courseRank[i].courseId,title:_courseRank[i].title,total:_courseRank[i].week,compare:0, dest: _courseRank[i].dest})
          }
          _courseLastWeek = _courseLastWeek.sort((a,b)=>b.total - a.total)

          _courseNow =  _courseNow.filter((item,index) => {
            _courseLastWeek.filter((item2,index2) => {
              if(item.courseId == item2.courseId){
                item.compare = index2 - index
              }
            })
            return item
          })
          this.courseRankData = this.courseRankData2 = _courseNow

          let _userOnlineTime = (res.data[7][0].time / 60 / 60).toFixed(0); //在线时间
          this.yearArray = this.OnlineDuration[0] = _userOnlineTime
          this.OnlineDuration[1] = (parseInt(_userOnlineTime) / res.data[3][0].count).toFixed(0)


          let _loginTime = res.data[8] // 3个月的登录频次
          this.LoginFrequency[1] = res.data[9][0].count // 教师登录频次
          this.LoginFrequency[2] = res.data[10][0].count // 学生登录频次
          this.LoginFrequency[0] = this.LoginFrequency[1] + this.LoginFrequency[2]
          this.LoginFrequency[3] = (this.LoginFrequency[0] / res.data[3][0].count).toFixed(0)
          let _loginTimearray = {}
          for(let i = 0;i < _loginTime.length;i++){
            _loginTimearray[_loginTime[i].time] = _loginTime[i].usernum
          }
          this.loginCountYearArray = _loginTimearray

          let _course = res.data[11] // 带分类的课程
          let weekArray = {
            lastWeek: [], //上周
            toWeek: [], //本周
          };
          weekArray = this.getMonth();
          let weekCourse = [];
          let weekCourse2 = [];
          let lastWeekCouseCount = 0
          let toWeekCouseCount = 0
          for (var z = 0; z < _course.length; z++) {
            let _date = new Date(weekArray.lastWeek[0]);
            console.log(_date);
            if (
              new Date(_course[z].create_at) > _date &&
              _course[z].pid == "34628934-d02f-11ec-8c78-005056b86db5"
            ) {
              weekCourse.push(_course[z]);
              var a = new Date(_course[z].create_at);
              var string =
                a.getFullYear() + "-" + (a.getMonth() + 1) + "-" + a.getDate();
              if (weekArray.lastWeek.indexOf(string) != -1) {
                lastWeekCouseCount++;
              } else {
                toWeekCouseCount++;
              }
            }
          }

          let lastCourseidWeek = [];
          let toCourseidWeek = [];
          for (var i = 0; i < _grade.length; i++) {
            weekCourse2.push({
              name: _grade[i].name,
              id: _grade[i].id,
              lastCourse: 0,
              toCourse: 0,
            });
            for (var z = 0; z < weekCourse.length; z++) {
              if (weekCourse[z].typeid == _grade[i].id) {
                var a = new Date(weekCourse[z].create_at);
                var string =
                  a.getFullYear() +
                  "-" +
                  (a.getMonth() + 1) +
                  "-" +
                  a.getDate();
                if (weekArray.lastWeek.indexOf(string) != -1) {
                  weekCourse2[i].lastCourse++;
                  if (lastCourseidWeek.indexOf(weekCourse[z].courseid) === -1) {
                    lastCourseidWeek.push(weekCourse[z].courseid);
                  }
                } else {
                  weekCourse2[i].toCourse++;
                  if (toCourseidWeek.indexOf(weekCourse[z].courseid) === -1) {
                    toCourseidWeek.push(weekCourse[z].courseid);
                  }
                }
              }
            }
          }
          this.weekCourse2 = weekCourse2;

          this.areaArray = res.data[12]
          this.schoolRankData = this.schoolRankData2 = res.data[13]
          this.$forceUpdate();
        })
        .catch((err) => {
          this.isLoading = false;
          this.$message.error(
            "因加载数据量过大，服务器统计异常，请联系管理员。"
          );
          console.error(err);
        });
    },
  },
};
</script>


<style scoped>
.body1 {
  width: 100%;
  height: 100%;
  display: flex;
  padding: 20px;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
}

.left {
  width: calc(100% / 4 * 1);
  height: 100%;
}

.left > .top {
  width: 100%;
  height: calc(100% / 5 * 2.7 - 5px);
  /* background: #fff; */
  border-radius: 5px;
  margin: 0 0 10px 0;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.8) 0%, rgba(224, 234, 251, 0.8) 100%);
  border: 2px solid #fff;
  box-sizing: border-box;
	display: flex;
	flex-direction: column;
}

.left > .bottom {
  width: 100%;
  height: calc(100% / 5 * 2.3 - 5px);
  /* background: #fff; */
  border-radius: 5px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.8) 0%, rgba(224, 234, 251, 0.8) 100%);
  border: 2px solid #fff;
  box-sizing: border-box;
	display: flex;
	flex-direction: column;
}

.center {
  width: calc(100% / 4 * 2 - 20px);
  height: 100%;
  margin: 0 10px;
}

.center > .top {
  width: 100%;
  height: calc(100% / 5 * 2.7 - 5px);
  /* background: #fff; */
  border-radius: 5px;
  margin: 0 0 10px 0;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.8) 0%, rgba(224, 234, 251, 0.8) 100%);
  border: 2px solid #fff;
  box-sizing: border-box;
	display: flex;
	flex-direction: column;
}

.center > .bottom {
  width: 100%;
  height: calc(100% / 5 * 2.3 - 5px);
  /* background: #fff; */
  border-radius: 5px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.8) 0%, rgba(224, 234, 251, 0.8) 100%);
  border: 2px solid #fff;
  box-sizing: border-box;
	display: flex;
	flex-direction: column;
}

.right {
  width: calc(100% / 4 * 1);
  height: 100%;

}

.right > .top {
  width: 100%;
  height: calc(100% / 5 * 2.7 - 5px);
  /* background: #fff; */
  border-radius: 5px;
  margin: 0 0 10px 0;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.8) 0%, rgba(224, 234, 251, 0.8) 100%);
  border: 2px solid #fff;
  box-sizing: border-box;
	display: flex;
	flex-direction: column;
}

.right > .bottom {
  width: 100%;
  height: calc(100% / 5 * 2.3 - 5px);
  /* background: #fff; */
  border-radius: 5px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.8) 0%, rgba(224, 234, 251, 0.8) 100%);
  border: 2px solid #fff;
  box-sizing: border-box;
	display: flex;
	flex-direction: column;
}

.titleBox {
  height: 40px;
  display: flex;
  align-items: center;
  padding: 0 15px;
  box-sizing: border-box;
  width: 100%;
  position: relative;
}

.titleBox::after {
  content: '';
  position: absolute;
  height: 2px;
  width: calc(100% - 30px);
  bottom: 0;
  background: linear-gradient(90deg, rgba(54, 129, 252, 0.6) 0%, rgba(54, 129, 252, 0.1) 100%);
}

.title {
  color: #060e17;
  margin-right: 25px;
  font-weight: 700;
  display: flex;
  align-items: center;
	position: relative;
}

.title::before{
  content: '';
  background-image: url('../../../../../assets/icon/test/data_title_icon.png');
  background-size: 100% 100%;
  width: 20px;
  height: 20px;
  margin-right: 5px;
}

.dataBox {
	flex: 1;
  /* height: calc(100% - 40px); */
  width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
}

/* .middleBox {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
} */



/* .teaMiddle {
  width: calc(100% / 2 - 10px);
  height: 60px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 0 10px;
  margin: 0 10px;
} */

/* .teaMiddle {
  width: calc(100% / 3 - 10px);
} */

/* .timeDiv {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  margin: 0 0 0 15px;
} */

/* .timeDiv > div {
  margin-right: 10px;
  cursor: pointer;
} */

/* .cNum {
  background: linear-gradient(
    180deg,
    rgb(125, 227, 174, 0.2) 0%,
    rgb(23, 196, 105, 0.3) 100%
  ) !important;
} */

/* .tNum {
  background: linear-gradient(
    180deg,
    rgb(174, 204, 254, 0.2) 0%,
    rgb(54, 129, 252, 0.3) 100%
  ) !important;
} */

/* .tSum {
  background: linear-gradient(
    180deg,
    rgb(125, 227, 174, 0.2) 0%,
    rgb(23, 196, 105, 0.3) 100%
  ) !important;
} */

/* .teaLeft > div:first-child,
.teaMiddle > div:first-child {
  font-size: 12px;
  font-weight: 400;
  color: #565e6a;
} */

/* .teaLeft > div:last-child,
.teaMiddle > div:last-child {
  font-size: 22px;
  font-weight: bold;
  color: #060e17;
} */

/* .halfBox {
  width: 50%;
} */

/* .isClick {
  box-sizing: border-box;
} */

/* .noClick{
  font-weight: 500;
  opacity: .6;
} */

/* .otherCss {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-end;
} */

/* .otherImg {
  width: 20px;
  height: 20px;
  margin: 0 10px;
  cursor: pointer;
} */

/* .otherImg > img {
  width: 100%;
  height: 100%;
} */

/* .allBox {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
} */

/* .allBox_left {
  width: 30%;
  height: 100%;
} */

/* .allBox_right {
  display: flex;
  flex-wrap: wrap;
  height: 100%;
  width: 70%;
  margin: 0 auto;
  overflow: hidden;
  justify-content: space-between;
} */

/* .depth {
  width: calc(100% / 4 - 10px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
} */

/* .depth > span:nth-child(1) {
  font-size: 14px;
  font-weight: 700;
  margin: 0 0 10px;
} */

/* .depth > div:nth-child(1) {
} */

.selectBox {
  width: 100px;
	position: absolute;
	right: 20px;
}

.selectBox >>> .el-input__inner {
  height: 30px;
  line-height: 30px;
  border: 1px solid #3681FC;
}

.selectBox >>> .el-input__icon {
  line-height: 30px;
}

.info_box {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-around;
  width: 90%;
  margin: 0 auto;
}

.info_box>.info2,
.info_box>.info3,
.info_box>.info {
  width: calc(50% - 10px);
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  height: 60px;
  justify-content: center;
	align-items: center;
  padding: 0 10px;
  box-sizing: border-box;
  margin-top: 10px;
  border-radius: 5px;
}

.info_box>.info2 {
  width: calc(100% / 4 - 10px);
}

.info_box>.info3 {
  width: calc(100% / 3 );
  margin-bottom: 5px;
}

.info_box>.info2>span:nth-child(1),
.info_box>.info3>span:nth-child(1),
.info_box>.info>span:nth-child(1) {
	font-size: 24px;
  font-weight: 700;
}

.info_box>.info2>span:nth-child(2),
.info_box>.info3>span:nth-child(2),
.info_box>.info>span:nth-child(2) {
  font-size: 12px;
  color: #565e6a;
  /* white-space: pre-wrap; */
  white-space: nowrap;
  word-break: break-all;
}

</style>


// WEBPACK FOOTER //
// src/components/pages/sz/dataBoardCity/dataCenter/index.vue